angular.module('lf.desktop')

.factory('popoversService', function ($rootScope) {
  var popovers = {};

  var popoversService = {

    register: function (name) {
      if (popovers[name]) {
        throw new Error('Popovers Service: [register] popover with name `' + name + '` already registered');
      }
      popovers[name] = {
        name: name,
        status: 'hidden'
      }
    },

    unregister: function (name) {
      if (!popovers[name]) {
        throw new Error('Popovers Service: [unregister] there is no popover with name `' + name + '`');
      }
      delete popovers[name];
    },

    get: function (name) {
      return popovers[name];
    },
    
    bindPopover: function (name, args) {
      $rootScope.$broadcast('popover:bind', {name: name, el: args.el});
    },

    show: function (name, opts) {
      if (!popovers[name]) {
        throw new Error('Popovers Service: [show] there is no popover with name `' + name + '`');
      }
      opts = opts || {};
      opts.name = name;
      $rootScope.$broadcast('popover:show', opts);
    },

    hide: function (name, opts) {
      if (!popovers[name]) {
        throw new Error('Popovers Service: [hide] there is no popover with name `' + name + '`');
      }
      opts = opts || {};
      opts.name = name;
      $rootScope.$broadcast('popover:hide', opts);
    },

    hideAll: function (opts) {
      opts = opts || {};
      _.keys(popovers).forEach(function (name) {
        if (opts.except === name) return;
        popoversService.hide(name, opts);
      });
    },
    
    nextZIndex: 10000
  }

  return popoversService;

});
